function Loader(props) {
  return (
    <div className={`mm-page-is-loading ${props.customClass}`}>
      <div className="mm-dots-loading-xl" id="mm-spinner" />
    </div>
  );
}

export default Loader;
